// SAP Hybris Assisted Services Module
export const isASM = () => !!window.ASM;
